'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _expanders = require('../../const/expanders');

var _expanders2 = require('../../utils/expanders');

var _formatting = require('../../utils/formatting');

var minMaxExpander = function minMaxExpander() {
  return function (propName, style) {
    return (0, _ramda.converge)(_ramda.pipe, [_expanders2.expandMainProp, (0, _expanders2.expandSubProps)(_formatting.prependSubToProp, _expanders.MIN_MAX_LIST)])(propName, style)({});
  };
};

exports.default = minMaxExpander;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/build/expanders/minMaxExpander.js
// module id = 650
// module chunks = 168707334958949